import { countries } from '@topcon/topcon-utils';
import { TeContainerSlim } from '@topcon/tuicl-react';
import styled from 'styled-components';

import { getCountryName } from '../../../../utils/formatAddress';
import { UNKNOWN_VALUE } from '../constants';
import CellText from './CellText';

export interface CountryCellProps {
  /** 2-letter ISO country code, e.g. `customer.companyAddress.country`. */
  countryCode: string | undefined;
}

/** Figma `te-flag` size S: 16×12, 1px radius. Decorative; the name beside it
 * is the accessible text. */
const Flag = styled.img`
  flex: none;
  width: 16px;
  height: 12px;
  border-radius: 1px;
`;

/** `te-text` is `flex: 0 0 auto`; it only truncates inside a block that can
 * shrink below its content width. */
const Name = styled.div`
  min-width: 0;
`;

/**
 * Country cell: flag + `getCountryName(countryCode)`, per the Figma
 * `country-slot` (flag, `xs` gap, name). The flag SVG comes from
 * `@topcon/topcon-utils`' country list; a code it doesn't know renders the
 * name (or raw code) alone.
 */
export default function CountryCell({ countryCode }: CountryCellProps) {
  if (!countryCode) return <CellText text={UNKNOWN_VALUE} />;

  const flagSrc = countries.getFlagSVG(countryCode);
  return (
    <TeContainerSlim alignItems="center" gap="xs" fill>
      {flagSrc && <Flag src={flagSrc} alt="" />}
      <Name>
        <CellText text={getCountryName(countryCode)} />
      </Name>
    </TeContainerSlim>
  );
}
